<div *ngIf="jsonLD" [innerHTML]="sanitizeJsonLD()"></div>

<div class="w-full fixed top-0 z-10">
<div class="container mx-auto max-w-7xl ">



<nav class="bg-gray-50">
  <div class=" px-2 sm:px-6 lg:px-8">
    <div class="relative flex h-16 items-center justify-between">

<!--      <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">-->
<!--        &lt;!&ndash; Mobile menu button&ndash;&gt;-->
<!--        <button type="button" class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset" aria-controls="mobile-menu" aria-expanded="false">-->
<!--1-->
<!--        </button>-->
<!--      </div>-->
      <div *ngIf="site" class="flex flex-1 items-center justify-start sm:items-stretch sm:justify-start">
        <div class="flex shrink-0 items-center ">
          <a class="navbar-brand" href="#"><img [attr.alt]="site.name+' logo'"
                                                [ngSrc]="'/logo.svg'"
                                                [priority]="true"
                                                fill style="width:130px; position: relative"></a>
        </div>
        <div class="hidden md:flex ml-6 items-center ">
          <div class="flex space-x-1 items-center h-100">

            <a *ngFor="let theme of site.themes" [attr.title]="theme.name" [attr.alt]="theme.name"  href="/{{theme.slug}}" class="rounded-md px-2 py-2 text-sm font-medium text-gray-800 hover:bg-gray-200 hover:text-gray-900" aria-current="page">{{theme.name}}</a>


          </div>
        </div>
      </div>

    </div>
  </div>




  <!-- Mobile menu, show/hide based on menu state. -->
<!--  <div class="sm:hidden" id="mobile-menu">-->
<!--    <div class="space-y-1 px-2 pt-2 pb-3">-->
<!--      &lt;!&ndash; Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" &ndash;&gt;-->
<!--      <a href="#" class="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white" aria-current="page">Dashboard</a>-->
<!--      <a href="#" class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Team</a>-->
<!--      <a href="#" class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Projects</a>-->
<!--      <a href="#" class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">Calendar</a>-->
<!--    </div>-->
<!--  </div>-->
</nav>

</div>
</div>


<!--<div class="container mx-auto" style="-->
<!--    background: #fff;-->
<!--    padding: 0;-->
<!--">-->
<!--  <nav class="navbar container fixed-top navbar-expand-lg bg-body-tertiary">-->
<!--    <div class="container">-->

<!--      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">-->
<!--        <span class="navbar-toggler-icon"></span>-->
<!--      </button>-->
<!--      <div class="collapse navbar-collapse" id="navbarNav">-->
<!--        <ul class="navbar-nav">-->
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" title="Семья и дети" alt="Семья и дети"  href="/family">Семья и дети</a>-->
<!--          </li>-->
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" title="Личность и характер" alt="Личность и характер" href="/person">Личность и характер</a>-->
<!--          </li>-->
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" title="Работа и карьера" alt="Работа и карьера"  href="/work">Работа и карьера</a>-->
<!--          </li>-->
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" title="Техники и практики" alt="Техники и практики"  href="/methods">Техники и практики</a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  </nav>-->
<!--</div>-->
<div class="mt-16 container mx-auto max-w-7xl ">
<!--  <div>{{site|json}}</div>-->
<!--  {{getHost()}}-->
<router-outlet *ngIf="site"></router-outlet>

</div>
